'use strict';

var button = require('../../../../../../../../../../_virtual/button2.cjs');

var hasRequiredButton;

function requireButton () {
	if (hasRequiredButton) return button.__exports;
	hasRequiredButton = 1;

	var BUTTON_VARIANTS = /*#__PURE__*/ function(BUTTON_VARIANTS) {
	    BUTTON_VARIANTS["primary"] = "primary";
	    BUTTON_VARIANTS["secondary"] = "secondary";
	    BUTTON_VARIANTS["tertiary"] = "tertiary";
	    return BUTTON_VARIANTS;
	}({});
	var PRIMARY_SECONDARY_BUTTON_VARIANTS = /*#__PURE__*/ function(PRIMARY_SECONDARY_BUTTON_VARIANTS) {
	    PRIMARY_SECONDARY_BUTTON_VARIANTS["primary"] = "primary";
	    PRIMARY_SECONDARY_BUTTON_VARIANTS["secondary"] = "secondary";
	    return PRIMARY_SECONDARY_BUTTON_VARIANTS;
	}({});

	button.__exports.BUTTON_VARIANTS = BUTTON_VARIANTS;
	button.__exports.PRIMARY_SECONDARY_BUTTON_VARIANTS = PRIMARY_SECONDARY_BUTTON_VARIANTS;
	
	return button.__exports;
}

exports.__require = requireButton;
//# sourceMappingURL=button.cjs.map
